/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FunctionComponent, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { closeDialog } from '../../../app/dialog/dialog.actions';
import { AgendaDialogList } from '../../pages/common/agenda-items/AgendaDialogList';

import { ConnectedDialog } from '../ConnectedDialog';
import { IAgendaItemsDialogProps } from './types';

export const AgendaItemsDialog: FunctionComponent<IAgendaItemsDialogProps> = () => {
  const dispatch = useDispatch();
  // const [updateShowLoader, updateError] = useApiRequestStatus();

  const onClose = useCallback(() => {
    dispatch(closeDialog('agendaItemsDialog'));
  }, [dispatch]);

  return (
    <ConnectedDialog dialogKey="agendaItemsDialog">
      <div className="popup sort_widgets_popup">
        <div className="panel">
          <div className="panel-header small-header flex jcsb">
            <h3>Show/Hide Widgets</h3>
            <span className="close-popup close" onClick={onClose}>
              <i className="icon-close" />
            </span>
          </div>
          <div className="panel-body p-0">
            <AgendaDialogList />
          </div>
          <div className="panel-footer flex jcr">
            <a onClick={onClose} className="link blueGray mr-2 close">
              Close
            </a>
            <a className="btn btn-green save_widgets_order">Save</a>
          </div>
        </div>
      </div>
    </ConnectedDialog>
  );
};
